import React from 'react';

import CoachmarkState from '../../../view_models/CoachmarkState';

const CoachmarkContext = React.createContext<CoachmarkState | null>(null);

export default CoachmarkContext;
